import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timestampToLocaleString'
})
export class TimestampToLocaleStringPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return null;
  }

}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/common/pipes/timestamp-to-locale-string.pipe.ts